export const es = {
  categories: [
    {
      id: 1,
      label: 'Cursos de Fotografía y Video',
      href: '/es/cursos-online-fotografia-y-video/',
    },
    {
      id: 2,
      label: 'Cursos de Marketing',
      href: '/es/cursos-online-marketing/',
    },
    {
      id: 3,
      label: 'Cursos de Modelado y Animación 3D',
      href: '/es/cursos-online-modelado-y-animacion-3d/',
    },
    {
      id: 4,
      label: 'Cursos de Liderazgo',
      href: '/es/cursos-online-liderazgo/',
    },
    {
      id: 5,
      label: 'Cursos de Desarrollo Productos Digitales',
      href: '/es/cursos-online-diseno-y-desarrollo-de-productos-digitales/',
    },
  ],
  subcategories: [
    {
      id: 6,
      label: 'Cursos de Estilo de Vida',
      href: '/es/cursos-online-estilo-de-vida/',
    },
    {
      id: 7,
      label: 'Cursos de Redes Sociales',
      href: '/es/cursos-online-redes-sociales/',
    },
    {
      id: 8,
      label: 'Cursos de Diseño de interiores',
      href: '/es/cursos-online-diseno-de-interiores/',
    },
    {
      id: 9,
      label: 'Cursos de Administración y finanzas',
      href: '/es/cursos-online-administracion-y-finanzas/',
    },
    {
      id: 10,
      label: 'Cursos de Lettering',
      href: '/es/cursos-online-lettering/',
    },
  ],
  softwares: [
    {
      id: 11,
      label: 'Cursos de Microsoft Excel',
      href: '/es/cursos-online-microsoft-excel/',
    },
    {
      id: 12,
      label: 'Cursos de Adobe Photoshop',
      href: '/es/cursos-online-adobe-photoshop/',
    },
    {
      id: 13,
      label: 'Cursos de After Effects',
      href: '/es/cursos-online-adobe-after-effects/',
    },
    {
      id: 14,
      label: 'Cursos de Google Ads',
      href: '/es/cursos-online-google-ads/',
    },
    {
      id: 15,
      label: 'Cursos de Procreate',
      href: '/es/cursos-online-procreate/',
    },
  ],
  specializations: [
    {
      id: 17,
      label: 'UX/UI para diseño de productos',
      href: '/microdegree/ux-ui/',
    },
    {
      id: 18,
      label: 'Marketing Digital',
      href: '/microdegree/marketing-digital/',
    },
    {
      id: 19,
      label: 'Degree de Data Analytics',
      href: '/microdegree/data-analytics/',
    },
    {
      id: 20,
      label: 'Product Management',
      href: '/microdegree/product-management/',
    },
  ],
};
